import React, {Component} from 'react';
import {Container, Grid, Col, Panel, /*ControlLabel,*/ Button, Alert} from 'rsuite';
import {withTranslation} from 'react-i18next';
import Layout from '../../../components/Layout';
import Geocode from "react-geocode";
/*import {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';*/

import AddressForm from '../../../components/settings/general/AddressForm';

// set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
Geocode.setApiKey("AIzaSyAig1H6xWKyyS5J6NeADJhi8YR2A2N6akI");
  
// set response language. Defaults to english.
Geocode.setLanguage("es");

// set response region. Its optional.
// A Geocoding request with region=es (Spain) will return the Spanish city.
//Geocode.setRegion("es");

// Enable or disable logs. Its optional.
Geocode.enableDebug();

export class NewLocation extends Component {
    constructor(props){
        super(props);

        this.cancel = this.cancel.bind(this);
        this.saveLocation = this.saveLocation.bind(this);

        this.state = {
            optionForm: "new",
            language:""
        }
    }

    componentDidMount(){
        this.setState({optionForm:this.props.match.params.optionForm});
    }

    cancel(){
		this.props.history.push("/settings/locations");
	}
    
    async saveLocation(){        
        var accountId  = atob(sessionStorage.getItem(btoa('account_id')));
        accountId = accountId.substring(1, accountId.length - 1);
        if(this.props.isValidForm('div.form-location')){	

            var obj = {
                type: this.address_form.state.type,
                name: this.address_form.state.name,
                // AddressForm guarda latitude/longitude con .toFixed(4), que
                // devuelve string — si se manda así al backend y luego se
                // relee, "latitude".toFixed(4) en getLocations() truena
                // porque .toFixed no existe en strings. Se fuerza a number
                // acá, en el único punto donde se arma el payload.
                latitude: parseFloat(this.address_form.state.latitude),
                longitude: parseFloat(this.address_form.state.longitude),
                address: this.address_form.state.address
            };
            

            if(this.state.optionForm === "edit"){
                obj.id = this.props.match.params.locationId;
            }

			let req = {
                api:'accounts',
                method: this.state.optionForm === "new"? "post" : "put",
                url: this.state.optionForm === "new"? "locations/by-account/"+accountId : "locations/by-account/"+obj.id+"/"+accountId,
                obj:obj,
                requireToken:true,
                modal:this.props.modal_loader,
                message_modal:this.props.t('modal.spin.start')
            }
    
            let request = await this.props.fetchRequest(req);
    
            if(request !== undefined){
                this.props.history.push('/settings/locations');
            }else {
                Alert.error(this.props.t('error_alert.no_save'));
            }
  		}else{
            Alert.error(this.props.t('error_alert.incomplete_fields'));
  		}
    }

    render(){
        const {t} = this.props;
        return(
            <Layout {...this.props}>
                <h3 className="s-title-page">{t('screen.settings.location.form.title_'+this.state.optionForm)}</h3>
                <Container>
                    <Panel shaded className="panel-general">
                        <AddressForm {...this.props}
                            form="location"
                            optionForm={this.state.optionForm}
                            onRef={ref => this.address_form = ref}
                        />
                        {this.state.optionForm !== 'details'?
                            <Grid className="form-group" fluid>
                                <Col xs={24} >
                                    <Button appearance="primary" style={{marginRight:8}} onClick={()=>this.saveLocation()}>{t('button.save')}</Button>
                                    <Button appearance="default" onClick={()=>this.cancel()}>{t('button.cancel')}</Button>
                                </Col>
                            </Grid>
                        :
                            <Grid fluid className="form-group" >
                                <Col smOffset={11} xs={24} sm={2} >
                                    <Button appearance="default" onClick={()=>this.cancel()}>{t('button.cancel')}</Button>
                                </Col>
                            </Grid>
                        }
                    </Panel>
                </Container>
            </Layout>
        )
    }
}
export default withTranslation('translations') (NewLocation)
//export default withTranslation('translations') ( NewLocation);